import React, { FC } from "react";

import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import Lottie from "react-lottie-player";
import lottieAnimation from "../../images/lottie.json";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 lg:pb-64 ">
          <h1 className="font-medium text-4xl md:text-5xl xl:text-7xl !leading-[114%] ">
            Povećaj prodaju, <br />{" "}
            <span className="text-[#4F46E5] font-bold">Izgradi brend</span>
          </h1>
          <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
            Želiš da konačno podigneš biznis na viši nivo, povećaš prodaju i
            izgradiš brend? Mi smo tvoj prijatelj ka postizanju digitalnih
            uspeha!
          </span>
        </div>
        <div className="flex-grow">
          <Lottie
            loop
            animationData={lottieAnimation}
            play
            style={{ width: "100%", height: "100%" }}
          />
        </div>
      </div>

      <div className="z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SectionHero;